import SimpleFilledButton from "./SimpleFilledButton";
export default SimpleFilledButton;
